<template>
  <div class="scheduleList">
    <FORM ref="childForm" @formclick="formclick" :formData="formData" v-if="isReady"></FORM>
    <table-page ref="childTable" @checkbox="checkbox" @btnclick="btnclick" :pageData="pageData"></table-page>
    <UPDATE ref="childUpdate" @submit="submit" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>
import Qs from 'qs'
import Url from '@/views/analyse/util/url'
import FORM from '@/components/page/form'
import tablePage from '@/components/page/table'
import UPDATE from '@/components/page/update'
import DataUtil from '@/utils/dataUtil'

//全部短信群组
//key = groupId
//value = groupName
//status
let allGroupList = []

//有效短信群组
//key = groupId
//value = groupName
let activeGroupList = []

//全部短信模板
//key = templateId
//value = templateName
//status
let allTemplateList = []

//有效短信模板
//key = templateId
//value = templateName
//templateContent
let activeTemplateList = []

//触发频率
const scheduleCronList = [
  {key:"0 * * * * *", value:"每分钟"},
  {key:"0 0,5,10,15,20,25,30,35,40,45,50,55 * * * *", value:"每5分钟"},
  {key:"0 0,15,30,45 * * * *", value:"每15分钟"},
  {key:"0 0,30 * * * *", value:"每30分钟"},
  {key:"0 0 * * * *", value:"每小时"},
  {key:"0 0 12 * * *", value:"每天12:00"},
  {key:"0 0 13 * * *", value:"每天13:00"},
  {key:"0 0 17 * * *", value:"每天17:00"},
  {key:"0 0 12 1 * *", value:"每月第1日12:00"},
]

//设置状态
const scheduleStatusList = [
  {key:0, value:"暂停"},
  {key:1, value:"启动"},
]

export default {
  name: 'scheduleList',
  components: {
    FORM,
    tablePage,
    UPDATE
  },
  data() {
    return {
      queryData: {},
      /*form查询表单*/
      formData: {
        hasLable: true,
        cols: []
      },
      /*table查询记录*/
      pageData: {
        queryUrl: Url.sms.autoScheduleList,
        selection: true,
        sequence: false,
        method: 'get',
        cols: [
          { title: '设置名称', field: 'scheduleName' },
          { title: '用戶群组', field: 'groupId', render: (data, full) => {
              let g = allGroupList.find(e => e.key === data)
              if (g == undefined) {
                return ""
              } else {
                if (g.status == 0) {
                  return "<span style='color:red'>" + g.value + "</span>"
                } else {
                  return g.value
                }
              }
            }
          },
          { title: '模板名称', field: 'templateId', render: (data, full) => {
              let t = allTemplateList.find(e => e.key === data)
              if (t == undefined) {
                return ""
              } else {
                if (t.status == 0) {
                  return "<span style='color:red'>" + t.value + "</span>"
                } else {
                  return t.value
                }
              }
            }
          },
          { title: '设置状态', field: 'scheduleStatus', width: '100px', render: (data, full) => {return scheduleStatusList.find(e => e.key === data).value} },
          { title: '最后触发时间', field: 'lastTriggerTime', width: '150px', render: (data, full) => {return DataUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')} },
          { title: '创建时间', field: 'createTime', width: '150px', render: (data, full) => {return DataUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')} },
          { title: '更新时间', field: 'updateTime', width: '150px', render: (data, full) => {return DataUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')} },
          {
            title: window.$t('common.operation'),
            btnClick: [
              {
                name: window.$t('common.edit'),
                click: window.$t('common.edit'),
                type: 'primary',
                icon: 'el-icon-edit',
                auth: 'analyse:sms:editAutoSchedule',
              },
            ]
          }
        ]
      },
      /*add或update浮窗表单*/
      updateData: {
        cols: []
      },
      /*其它*/
      selectData: {
        ids: ''
      },
      sendType: 0, //自动短信
      isReady: false, //加載狀態
    }
  },
  methods: {
    dataChange(url, option, suc, fail) {
      this.$axios.post(url, Qs.stringify(option || {})).then(res => {
        if (suc && (typeof suc == 'function')) suc(res)
      }).catch(res => {
        if (fail && (typeof fail == 'function')) fail(res)
      })
    },

    /*form按钮点击事件*/
    formclick(clickName, data) {
      if (clickName == window.$t('common.search')) {
        data.status = 1 //显示
        //data.sendType = this.sendType
        data.lastTriggerTimeStart = data.lastTriggerTimeStart ? new Date(data.lastTriggerTimeStart).getTime() : ''
        data.lastTriggerTimeEnd = data.lastTriggerTimeEnd ? new Date(data.lastTriggerTimeEnd).getTime() : ''
        this.queryData = data
        this.$refs.childTable.defaultQueryData(data)

      } else if (clickName == window.$t('common.addNew')) {
        this.$refs.childUpdate.open()

      } else if (clickName == window.$t('common.hide')) {
        if (this.selectData.ids == "") {
          this.$message.error('未选取记录')
        } else {
          this.$confirm('确定隱藏已选取的记录?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
          }).then(() => {
            this.dataChange(Url.sms.autoScheduleHide, this.selectData, res => {
              if (res.code == 0) {
                this.$message.success('操作成功')
                this.$refs.childTable.defaultQueryData(this.queryData)
              } else {
                this.$message.error(res.message)
              }
            })
          }).catch(() => {})
        }

      } else if (clickName == window.$t('common.start')) {
        if (this.selectData.ids == "") {
          this.$message.error('未选取记录')
        } else {
          this.$confirm('确定启动已选取的记录?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
          }).then(() => {
            this.dataChange(Url.sms.autoScheduleEnable, this.selectData, res => {
              if (res.code == 0) {
                this.$message.success('操作成功')
                this.$refs.childTable.defaultQueryData(this.queryData)
              } else {
                this.$message.error(res.message)
              }
            })
          }).catch(() => {})
        }

      } else if (clickName == window.$t('common.stop')) {
        if (this.selectData.ids == "") {
          this.$message.error('未选取记录')
        } else {
          this.$confirm('确定暂停已选取的记录?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
          }).then(() => {
            this.dataChange(Url.sms.autoScheduleDisable, this.selectData, res => {
              if (res.code == 0) {
                this.$message.success('操作成功')
                this.$refs.childTable.defaultQueryData(this.queryData)
              } else {
                this.$message.error(res.message)
              }
            })
          }).catch(() => {})
        }
      }
    },

    /*table按钮点击事件*/
    btnclick(clickName, row) {
      if (clickName == window.$t('common.edit')) {
        let g = activeGroupList.find(e => e.key === row.groupId)
        if (g == undefined) {
          row.groupId = ""
        }

        let t = activeTemplateList.find(e => e.key === row.templateId)
        if (t == undefined) {
          row.templateId = ""
          row.templateContent = ""
        } else {
          row.templateContent = t.templateContent
        }

        this.$refs.childUpdate.open(row)
      }
    },

    /*add或update提交数据触发事件*/
    submit(model) {
      this.dataChange(Url.sms.autoScheduleSave, model, res => {
        if (res.code == 0) {
          this.$refs.childUpdate.close()
          this.$message.success('操作成功')
          this.$refs.childTable.defaultQueryData(this.queryData)
        } else {
          this.$message.error(res.message)
        }
      })
    },

    /*其它*/
    checkbox(row) {
      this.selectData.ids = row.map(key => key.id).join(",");
    },
    loadTemplateContent(model, cols, col) {
      let t = activeTemplateList.find(e => e.key === col.data)
      if (t == undefined) {
        cols.find(c => c.field === 'templateContent').data = ""
      } else {
        cols.find(c => c.field === 'templateContent').data = t.templateContent
      }
    },
  },
  async created() {
    this.isReady = false
    try {
      const [groupRes, templateRes] = await Promise.all([
        this.$axios.get(Url.sms.autoGroupList + 
            "?pageNum=1" + 
            "&pageSize=-1"),
        this.$axios.get(Url.sms.templateList + 
            "?sendType=" + this.sendType + 
            "&pageNum=1" + 
            "&pageSize=-1"),
      ]);

      //初始化用戶群組選項
      if (groupRes.code == 0 && groupRes.result) {
        allGroupList = [];
        activeGroupList = [];
        let data = JSON.parse(JSON.stringify(groupRes.result.list));
        for (let i in data) {
          allGroupList.push({
            key: data[i].id,
            value: data[i].groupName,
            status: data[i].status,
          });
          if (data[i].status == 1) {
            activeGroupList.push({
              key: data[i].id,
              value: data[i].groupName,
            });
          }
        }
      }

      //初始化模板選項
      if (templateRes.code == 0 && templateRes.result) {
        allTemplateList = [];
        activeTemplateList = [];
        let data = JSON.parse(JSON.stringify(templateRes.result.list));
        for (let i in data) {
          allTemplateList.push({
            key: data[i].id,
            value: data[i].templateName,
            status: data[i].status,
          });
          if (data[i].status == 1) {
            activeTemplateList.push({
              key: data[i].id,
              value: data[i].templateName,
              templateContent: data[i].templateContent,
            });
          }
        }
      }
      
      /*表单初始化*/
      this.formData.cols = [
        { title: '用戶群组', field: 'groupId', type: 2, optionList: activeGroupList },
        { title: '短信模板', field: 'templateId', type: 2, optionList: activeTemplateList },
        { title: '模板名称', field: 'templateName' },
        { title: '模板内容', field: 'templateContent' },
        { title: '设置状态', field: 'scheduleStatus', type: 2, optionList: scheduleStatusList },
        { title: '最后触发时间', field: 'time', type: 6, format: 'yyyy-MM-dd HH:mm:ss', startEndParam: ['lastTriggerTimeStart', 'lastTriggerTimeEnd'] },
        { click: window.$t('common.search'), icon: 'el-icon-search' },
        { click: window.$t('common.addNew'), icon: 'el-icon-circle-plus-outline', auth: 'analyse:sms:addAutoSchedule' },
        { click: window.$t('common.hide'), icon: 'el-icon-delete', auth: 'analyse:sms:hideAutoSchedule' },
        { click: window.$t('common.start'), icon: 'el-icon-video-play', auth: 'analyse:sms:enableAutoSchedule' },
        { click: window.$t('common.stop'), icon: 'el-icon-video-pause', auth: 'analyse:sms:disableAutoSchedule' },
      ]
      this.updateData.cols = [
        { title: '序号', field: 'id', hidden: true },
        { title: '设置名称', field: 'scheduleName', required: true },
        { title: '用戶群组', field: 'groupId', type: 2, optionList: activeGroupList, required: true },
        { title: '模板名称', field: 'templateId', type: 2, optionList: activeTemplateList, change: this.loadTemplateContent, required: true },
        { title: '模板内容', field: 'templateContent', textType: 'textarea', readonly: true },
        { title: '发送次数', field: 'maxSend', type: 7, min: 0, data: 1, remarkType: true, remarkTxt: '(同一客戶最大發送次數, 0=无限制)', required: true },
        { title: '触发频率', field: 'scheduleCron', type: 2, optionList: scheduleCronList, required: true },
        { title: '设置状态', field: 'scheduleStatus', type: 2, optionList: scheduleStatusList, data: 0, required: true },
        { title: '备注', field: 'remark', textType: 'textarea' },
      ]

    } catch (error) {
      console.error("初始化失败", error);
    } finally {
      this.isReady = true
    }
  }
}
</script>
